'use strict';exports.__esModule = true;var CROPPER_CONFIG = {
    viewMode: 1,
    zoomTo: 0.5,
    dragMode: 'move',
    background: false,
    aspectRatio: 1,
    checkOrientation: false,
    style: { height: 400, width: '100%' },
    minCropBoxHeight: 50,
    minCropBoxWidth: 50,
    center: true,
    responsive: true,
    guides: true };exports.default =


CROPPER_CONFIG;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cropper/config.js
// module id = 2654
// module chunks = 0